import { MARQUEE_ITEMS } from "../i18n";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-[#1C1A17] bg-[#0A0A09] py-5">
      <div className="flex w-max animate-marquee gap-24 pr-24">
        {items.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center gap-24 whitespace-nowrap">
            <span className="text-xs font-mono tracking-[0.3em] text-[#827D72] uppercase">{item}</span>
            <span className="text-[#C8A86B] text-[8px]">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
